<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar title="KJU Portal" backgroundColor="primary" logo="/img/kjc-logo.png" :sidebarLinks="$sidebar.sidebarLinks" :userRoles="$currentUser.roles" v-if="$currentUser">
      <user-menu :title="$currentUser.name" :designation="$currentUser.designation ? $currentUser.designation : $currentUser.register_no" :roles="$currentUser.roles" :image="$currentUser.image"></user-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <router-view name="header"></router-view>

      <div :class="{content: !$route.meta.hideContent}" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>


/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}


import TopNavbar from './TopNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import MobileMenu from './Extra/MobileMenu.vue';
import UserMenu from './Extra/UserMenu.vue';
import { SlideYDownTransition, ZoomCenterTransition } from 'vue2-transitions';

import { mapGetters } from 'vuex'

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    UserMenu,
    SlideYDownTransition,
    ZoomCenterTransition
  },
  data(){
    return {

    }
  },
  // computed: {
  //   ...mapGetters({
  //       user: 'getCurrentUser',
  //   }),
  // },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  mounted() {
    let docClasses = document.body.classList;
    // let isWindows = navigator.platform.startsWith('Win');
    initScrollbar('sidebar');
    initScrollbar('sidebar-wrapper');
    docClasses.add('perfect-scrollbar-on');

    // if (isWindows) {
    //   // if we are on windows OS we activate the perfectScrollbar function
    //   initScrollbar('sidebar');
    //   initScrollbar('sidebar-wrapper');

    //   docClasses.add('perfect-scrollbar-on');
    // } else {
      
    //   docClasses.add('perfect-scrollbar-off');
    // }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.el-dialog__wrapper{
  position: fixed;
  height: 100vh;
  width: 50%;
  top: 0;
  right: 0px;
}

.el-drawer__body{
  padding: 10px;
}

.el-drawer__header{
  margin-bottom: 10px !important;
}
</style>
